import { format } from 'date-fns';

export function sliceScheduleYmd(value) {
  if (value == null || value === '') return null;
  return String(value).slice(0, 10);
}

export function scheduleTodayYmd() {
  return format(new Date(), 'yyyy-MM-dd');
}

/** Matches backend `machineBlockedForScheduleStart(machine, scheduleStartDate)`. */
export function isMachineSchedulingUnavailable(machine, referenceDateYmd) {
  if (!machine || !machine.schedulingBlocked) return false;
  const ref = sliceScheduleYmd(referenceDateYmd) || scheduleTodayYmd();
  const u = machine.schedulingBlockedUntil;
  if (!u) return true;
  return ref <= sliceScheduleYmd(u);
}

/** Short human-readable note for tooltips and flags; null if available. */
export function machineSchedulingUnavailableNote(machine, referenceDateYmd) {
  if (!isMachineSchedulingUnavailable(machine, referenceDateYmd)) return null;
  const reason = (machine.schedulingBlockReason || '').trim() || 'Unavailable for scheduling';
  const u = sliceScheduleYmd(machine.schedulingBlockedUntil);
  return u ? `${reason} (until ${u})` : reason;
}

/** Suffix for `<option>` / list labels, e.g. ` — ⚠ Breakdown (until 2026-04-01)`. */
export function machineSchedulingOptionSuffix(machine, referenceDateYmd) {
  const note = machineSchedulingUnavailableNote(machine, referenceDateYmd);
  return note ? ` — ⚠ ${note}` : '';
}
